/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateSalesOrderItemDto = {
  /**
   * Associated sales order ID (optional when nested under create-with-items)
   */
  orderId?: number;
  /**
   * Associated warehouse inventory product ID
   */
  warehouseInventoryProductId: number;
  /**
   * Original price of the product
   */
  originalPrice: number;
  /**
   * Markup type applied before discount
   */
  markupType: CreateSalesOrderItemDto.markupType;
  /**
   * Markup value
   */
  markupValue?: number;
  /**
   * Price after markup and before discount
   */
  adjustedPrice?: number;
  /**
   * Discount type
   */
  discountType: CreateSalesOrderItemDto.discountType;
  /**
   * Discount value
   */
  discountValue?: number;
  /**
   * Final price after markup and discount
   */
  finalPrice: number;
  /**
   * Whether the piece is handed to the customer on confirm (local pieces only)
   */
  isDelivered?: boolean;
};
export namespace CreateSalesOrderItemDto {
  /**
   * Markup type applied before discount
   */
  export enum markupType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
  /**
   * Discount type
   */
  export enum discountType {
    PERCENTAGE = 'PERCENTAGE',
    AMOUNT = 'AMOUNT',
    NONE = 'NONE',
  }
}
